import {firstValueFrom, fromEvent, Observable} from 'rxjs';
import 'reflect-metadata';
import {map, skipWhile, switchMap, take} from 'rxjs/operators';

export function IsLoggedIn(isLoggedIn: boolean = true) {
    return (target: unknown, propertyKey: string, descriptor: PropertyDescriptor): void | TypedPropertyDescriptor<() => void> => {
        const sourceMethod = descriptor.value;
        const returnType = Reflect.getMetadata('design:returntype', target as object, propertyKey)
            ?.toString() || '';
        const isObservableReturnType = returnType.indexOf('Observable') !== -1;
        if (isObservableReturnType) {
            descriptor.value = function (...args: Array<unknown>): Observable<unknown> {
                return fromEvent<CustomEvent>(window, 'loggedIn')
                    .pipe(
                        map((e: CustomEvent<boolean>) => e.detail),
                        skipWhile(loggedIn => loggedIn === !isLoggedIn),
                        switchMap(() => sourceMethod.apply(this, args)),
                    );
            };
        } else {
            descriptor.value = async function (...args: Array<unknown>): Promise<unknown> {
                await firstValueFrom(fromEvent<CustomEvent>(window, 'loggedIn')
                    .pipe(
                        map((e: CustomEvent<boolean>) => e.detail),
                        skipWhile(loggedIn => loggedIn === !isLoggedIn),
                        take(1)
                    ));
                return await sourceMethod.apply(this, args);
            };
        }
        return descriptor;
    };
}
